import { createRoute, redirect } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { workspaceRoute } from 'pages/NWPlatform/Workspaces/Workspace/Routing'

export const audioRoute = createRoute({
  getParentRoute: () => workspaceRoute,
  path: StaticRouteParameter.AUDIOS,
  beforeLoad: ({ location }) => {
    if (
      location.pathname.endsWith(StaticRouteParameter.AUDIOS) ||
      location.pathname.endsWith(`${StaticRouteParameter.AUDIOS}/`)
    ) {
      throw redirect({ replace: true, from: audioRoute.fullPath, to: 'streams' })
    }
  },
  loader: () => ({
    crumb: t('entity:content.audio', { count: 2 }),
  }),
})
